import styled from 'styled-components';
import { colors } from '../../../stylesheets';

export default styled.div`
  width: 70px;
  height: 70px;
  border-radius: 35px;
  background-color: ${(props) => colors[props.color]};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: -35px;
  border: 1px solid ${colors['backgroundGray']};
`;
